import { Link } from 'react-router-dom';
import SeoHelmet from '@/components/feature/SeoHelmet';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import {
  siteInfo,
  featuredArticles,
  latestArticles,
  exclusiveArticles,
  hotTags,
  comments,
} from '@/mocks/data';

function formatViews(num: number): string {
  if (num >= 10000) {
    return `${(num / 10000).toFixed(1)}万`;
  }
  return num.toLocaleString();
}

export default function Home() {
  const heroImage =
    'https://readdy.ai/api/search-image?query=Dark%20mysterious%20cityscape%20at%20night%20with%20dramatic%20red%20spotlights%20and%20shadowy%20silhouettes%2C%20cinematic%20atmosphere%2C%20entertainment%20scandal%20theme%2C%20high%20contrast%20black%20and%20red%20palette%2C%20editorial%20photography%20style%2C%20abstract%20gossip%20news%20visual%2C%20grainy%20texture&width=1920&height=1080&seq=hero-home&orientation=landscape';

  const ctaImage =
    'https://readdy.ai/api/search-image?query=Dark%20mysterious%20press%20room%20with%20spotlights%20and%20microphones%20on%20podium%2C%20dramatic%20red%20and%20black%20lighting%2C%20cinematic%20journalism%20atmosphere%2C%20high%20contrast%2C%20editorial%20photography%20style%2C%20breaking%20news%20theme&width=1920&height=600&seq=cta-home&orientation=landscape';

  const homeSchemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: `首页 - ${siteInfo.name}`,
      description: siteInfo.description,
      url: siteInfo.url,
      isPartOf: { '@type': 'WebSite', name: siteInfo.name, url: siteInfo.url },
      about: { '@type': 'Thing', name: '娱乐爆料资讯' },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: siteInfo.name,
      url: siteInfo.url,
      logo: siteInfo.logo,
      description: siteInfo.description,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.url,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteInfo.url}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <SeoHelmet
        title={`${siteInfo.name} - 今日吃瓜黑料每日更新`}
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        ogImage={heroImage}
        canonicalPath="/"
        schemas={homeSchemas}
      />
      <Navbar />

      {/* ===== HERO SECTION ===== */}
      <section className="relative min-h-[100dvh] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={heroImage}
            alt="91吃瓜网首页背景"
            className="w-full h-full object-cover"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />
        </div>

        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pb-16 md:pb-24 pt-32">
          <h1 className="text-white font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight mb-8 md:mb-12 max-w-3xl">
            全网第一手
            <br />
            明星黑料
            <br />
            吃瓜群众在线
          </h1>

          <div className="flex flex-col md:flex-row gap-6 md:gap-12 max-w-4xl">
            <div className="md:w-1/2">
              <p className="text-white/80 text-sm md:text-base leading-relaxed">
                91吃瓜网深耕娱乐爆料领域，汇聚全网第一手明星翻车、网红迷路、社会热点等爆料资讯。
                我们不做谣言传声筒，只做真相挖掘机——每一条爆料都经过多方验证，还原事件完整始末。
              </p>
            </div>
            <div className="md:w-1/2">
              <p className="text-white/80 text-sm md:text-base leading-relaxed">
                24小时不间断更新，重大事件发生后30分钟内发布快讯，48小时内推出深度调查报道。
                关注91吃瓜网，让你永远走在吃瓜前线，不错过任何一个娱乐圈大瓜。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FEATURE GRID: HOT GOSSIP ===== */}
      <section className="bg-background-100 py-12 md:py-20">
        <div className="px-4 md:px-8 lg:px-12">
          <div className="flex items-end justify-between mb-8 md:mb-12">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
                热门吃瓜
                <span className="text-primary-500 ml-2">黑料独家</span>
              </h2>
              <p className="text-foreground-500 text-sm mt-2">24小时不间断更新</p>
            </div>
            <span className="hidden md:inline-flex items-center px-4 py-1.5 rounded-full bg-foreground-950 text-background-50 text-xs font-medium">
              实时播报
            </span>
          </div>

          <div className="flex gap-4 md:gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide">
            {featuredArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="flex-shrink-0 w-[260px] md:w-[300px] snap-start group"
              >
                <div className="bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
                  <div className="relative h-[180px] md:h-[200px] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    {article.isExclusive && (
                      <span className="absolute top-3 left-3 px-2 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded">
                        独家
                      </span>
                    )}
                  </div>
                  <div className="p-4">
                    <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                      <span>{article.category}</span>
                      <span>·</span>
                      <span>{article.date}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <div className="flex items-center justify-between mt-3">
                      <span className="text-xs text-foreground-400">
                        {formatViews(article.views)} 阅读
                      </span>
                      {article.isHot && (
                        <span className="text-lg font-black text-primary-500">爆</span>
                      )}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ===== LATEST ARTICLES + SIDEBAR ===== */}
      <section className="bg-background-50 py-12 md:py-20">
        <div className="px-4 md:px-8 lg:px-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            {/* Main content */}
            <div className="lg:w-2/3">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8">
                最新爆料
              </h2>
              <div className="flex flex-col gap-6">
                {latestArticles.slice(0, 6).map((article) => (
                  <article key={article.id} className="flex flex-col sm:flex-row gap-4 group">
                    <Link
                      to={`/article/${article.slug}`}
                      className="sm:w-[200px] md:w-[260px] flex-shrink-0"
                    >
                      <div className="relative h-[160px] sm:h-[140px] rounded-lg overflow-hidden">
                        <img
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                          loading="lazy"
                        />
                        {article.isExclusive && (
                          <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-bold rounded">
                            独家
                          </span>
                        )}
                      </div>
                    </Link>
                    <div className="flex-1 flex flex-col justify-center">
                      <div className="flex items-center gap-2 text-xs text-foreground-400 mb-2 flex-wrap">
                        <span className="text-primary-600 font-medium">{article.category}</span>
                        <span>·</span>
                        <span>{article.date}</span>
                        <span>·</span>
                        <span>{formatViews(article.views)} 阅读</span>
                      </div>
                      <Link to={`/article/${article.slug}`}>
                        <h3 className="text-base md:text-lg font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                          {article.title}
                        </h3>
                      </Link>
                      <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed hidden sm:block">
                        {article.summary}
                      </p>
                    </div>
                  </article>
                ))}
              </div>

              <div className="mt-10 text-center">
                <Link
                  to="/category/social"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-200 text-foreground-700 text-sm font-medium hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all"
                >
                  查看更多爆料
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                </Link>
              </div>
            </div>

            {/* Sidebar */}
            <aside className="lg:w-1/3 flex flex-col gap-8">
              {/* Hot tags */}
              <div className="bg-background-100 rounded-xl p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4">
                  热门标签
                </h3>
                <div className="flex flex-wrap gap-2">
                  {hotTags.map((tag) => (
                    <Link
                      key={tag.name}
                      to="/category/social"
                      className="px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors"
                    >
                      {tag.name}
                      <span className="text-foreground-300 ml-1">({tag.count})</span>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Exclusive articles mini list */}
              <div className="bg-background-100 rounded-xl p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4">
                  独家爆料
                </h3>
                <div className="flex flex-col gap-4">
                  {exclusiveArticles.map((article) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.slug}`}
                      className="group flex gap-3"
                    >
                      <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
                        <img
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>
                      <div>
                        <h4 className="text-sm font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                          {article.title}
                        </h4>
                        <span className="text-xs text-foreground-400 mt-1">
                          {article.date}
                        </span>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIAL: USER REVIEWS ===== */}
      <section className="bg-background-100 py-12 md:py-20">
        <div className="px-4 md:px-8 lg:px-12">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <span className="w-2 h-2 bg-primary-500 rotate-45 inline-block" />
              站友辣评
            </div>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-primary-700">
              网友神评
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
            {comments.slice(0, 5).map((comment, index) => {
              const isLarge = index === 3;
              const isPhoto = index === 2;

              if (isLarge) {
                return (
                  <div
                    key={comment.id}
                    className="md:col-span-2 bg-foreground-900 rounded-xl overflow-hidden relative min-h-[220px]"
                  >
                    <img
                      src={comment.avatar}
                      alt={comment.user}
                      className="absolute inset-0 w-full h-full object-cover opacity-40"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/80 to-transparent" />
                    <div className="relative z-10 p-6 flex flex-col justify-end h-full min-h-[220px]">
                      <p className="text-white/90 text-sm md:text-base leading-relaxed mb-4 line-clamp-4">
                        "{comment.content}"
                      </p>
                      <div>
                        <p className="text-white font-semibold text-sm">{comment.user}</p>
                        <p className="text-white/50 text-xs">{comment.level}</p>
                      </div>
                    </div>
                  </div>
                );
              }

              if (isPhoto) {
                return (
                  <div
                    key={comment.id}
                    className="bg-foreground-900 rounded-xl overflow-hidden relative min-h-[200px]"
                  >
                    <img
                      src={comment.avatar}
                      alt={comment.user}
                      className="absolute inset-0 w-full h-full object-cover"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent" />
                    <div className="relative z-10 p-5 flex flex-col justify-end h-full min-h-[200px]">
                      <p className="text-white/90 text-sm leading-relaxed mb-3 line-clamp-3">
                        "{comment.content}"
                      </p>
                      <p className="text-white font-semibold text-sm">{comment.user}</p>
                      <p className="text-white/50 text-xs">{comment.level}</p>
                    </div>
                  </div>
                );
              }

              return (
                <div
                  key={comment.id}
                  className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={comment.avatar}
                      alt={comment.user}
                      className="w-10 h-10 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{comment.user}</p>
                      <p className="text-xs text-foreground-400">{comment.level}</p>
                    </div>
                  </div>
                  <i className="ri-double-quotes-l text-primary-300 text-lg mb-2 block" />
                  <p className="text-sm text-foreground-700 leading-relaxed line-clamp-4">
                    {comment.content}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ===== CTA SECTION ===== */}
      <section className="relative min-h-[400px] md:min-h-[500px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={ctaImage}
            alt="爆料征集背景"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/50" />
        </div>

        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-12 md:py-20">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
            <div className="md:w-1/2">
              <h2 className="text-white font-heading text-3xl md:text-4xl lg:text-5xl font-black leading-tight mb-6 md:mb-10">
                有料要爆？
              </h2>
              <Link
                to="/about"
                className="inline-flex items-center gap-3 bg-white text-foreground-950 px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                立即投稿
                <span className="w-8 h-8 rounded-full bg-foreground-950 text-white flex items-center justify-center">
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                </span>
              </Link>
            </div>
            <div className="md:w-1/2 md:text-right">
              <p className="text-white/80 text-sm md:text-base leading-relaxed">
                独家爆料经核实发布后，最高可获得5000元现金奖励
              </p>
              <p className="text-white/80 text-sm md:text-base leading-relaxed mt-2">
                爆料者身份严格保密，7×24小时接受投稿
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}